import {Component, inject, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {VERSION} from '../environments/version';
import { SharedModule } from './shared/shared.module';
import { SideBarComponent } from './shared/navbar/side-bar/side-bar.component';
import { TitleBarComponent } from './shared/components/title-bar/title-bar.component';
import { HeaderBarComponent } from './shared/navbar/header-bar/header-bar.component';
import { SpinnerComponent } from './shared/components/spinner/spinner.component';
import { AnalyticsInterceptor } from './analytics/analytics.interceptor';
import { RouterModule } from '@angular/router';

declare let $: any;

@Component({
  selector: 'app-sd-app',
  templateUrl: 'app.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SharedModule, SideBarComponent, TitleBarComponent, HeaderBarComponent, SpinnerComponent, RouterModule],
})
export class AppComponent implements OnInit {
  version: string;
  versionDetail: string;
  component: any;
  private analyticsInterceptor = inject(AnalyticsInterceptor);

  constructor() {
    this.version = VERSION.version;
    this.versionDetail = VERSION.hash;
  }

  ngOnInit(): void {
    this.changeSideBarWidth();
  }

  routerOutletActivated(component: any) {
    this.component = component;
  }

  changeSideBarWidth() {
    $('#sidebar-wrapper').hover(()=> {
      if($('#wrapper').hasClass('toggled')) {
        $('#brand').css('width', '250px');
      }
    }, () => {
      if($('#wrapper').hasClass('toggled')) {
        $('#brand').css('width', '4.6rem');
      }
    });
  }
}
